import { getApps, initializeApp } from "firebase/app";

const firebaseConfig = {
  apiKey: process.env.EXPO_PUBLIC_FIREBASE_API_KEY,
  authDomain: process.env.EXPO_PUBLIC_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.EXPO_PUBLIC_FIREBASE_PROJECT_ID,
  storageBucket: process.env.EXPO_PUBLIC_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.EXPO_PUBLIC_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.EXPO_PUBLIC_FIREBASE_APP_ID,
};

// Temporary masked diagnostics to verify runtime config (remove after validation)
if (typeof window !== "undefined") {
  const apiKey = process.env.EXPO_PUBLIC_FIREBASE_API_KEY || "";
  const projectId = process.env.EXPO_PUBLIC_FIREBASE_PROJECT_ID || "";
  const authDomain = process.env.EXPO_PUBLIC_FIREBASE_AUTH_DOMAIN || "";
  // Mask apiKey by showing only length
  console.info("[Firebase config]", {
    apiKeyLen: apiKey.length,
    projectId,
    authDomain,
  });
}

export const initializedFirebaseApp = !getApps().length ? initializeApp(firebaseConfig) : getApps()[0];
